import { render, staticRenderFns } from "./editAuthModal.vue?vue&type=template&id=5aa9dc56&scoped=true&"
import script from "./editAuthModal.vue?vue&type=script&lang=js&"
export * from "./editAuthModal.vue?vue&type=script&lang=js&"
import style0 from "./editAuthModal.vue?vue&type=style&index=0&id=5aa9dc56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa9dc56",
  null
  
)

export default component.exports